import React from 'react';
import PropTypes from 'prop-types';
import {locationShape} from 'react-router';

import Go from 'spa/Components/Go';

const AddTrailingSlash = ({location}) => (
  <Go to={`${location.pathname}/${location.search}`} statusCode={301} />
);
AddTrailingSlash.propTypes = {
  location: locationShape.isRequired, //eslint-disable-line react/no-typos
};

export default AddTrailingSlash;



// WEBPACK FOOTER //
// ./spa/Pages/AddTrailingSlash.jsx